import { useState } from "react";
import { type FormErrors, formErrors } from "./emailErrors";

export interface EmailFormSubmit {
  loading: boolean;
  errors: FormErrors;
  /** Runs `action` with the button spinning; a failure lands next to the field it's about. */
  run: (action: () => Promise<void>) => Promise<void>;
}

/** The submit state shared by the email dialogs; `fallback` is the message for unexpected failures. */
export function useEmailFormSubmit(fallback: string): EmailFormSubmit {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<FormErrors>({});

  async function run(action: () => Promise<void>): Promise<void> {
    setLoading(true);
    setErrors({});
    try {
      await action();
    } catch (err) {
      setErrors(formErrors(err, fallback));
    } finally {
      setLoading(false);
    }
  }

  return { loading, errors, run };
}
